'use client'

import { ItemArt } from '@/features/veluvit/components/ui/item-art'
import {
  GemIcon,
  TicketIcon,
} from '@/features/veluvit/components/ui/currency-icon'

import type { AttendReward } from '@/features/veluvit/lib/attendance'

const ART = { gem: 'gem', ticket: 'ticket' } as const

/**
 * 출석 보상 종류별 아이콘 — 크기는 부모 글자 크기를 따른다.
 * art: 게임 아이템 그림(20px 이상 자리 — 보상판 칸 · 획득 연출). 글자 안 작은 자리는 SVG 그대로(그림을 줄이면 뭉개진다).
 */
export default function RewardIcon({
  kind,
  className,
  art,
  px,
}: {
  kind: AttendReward['kind']
  className?: string
  art?: boolean
  px?: 64 | 128 | 256
}) {
  if (art)
    return <ItemArt name={ART[kind]} px={px ?? 128} className={className} />
  if (kind === 'ticket') return <TicketIcon className={className} />
  return <GemIcon className={className} />
}
